import { axiosInstance } from "@/helper/axios-instance";
import type { DataAwareResponse, DocumentTemplate } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useDocumentTemplateEdit() {
  return useMutationWithValidation({
    mutationFn: async (data: any) => {
      const response = await axiosInstance({
        method: "POST",
        url:  `DocumentTemplate/Edit`,
        data: data,
      });

      return response.data as DataAwareResponse<DocumentTemplate>;
    },
    retry: 2,
    customMessage: {
      success: "Document template updated successfully",
    },
  });
}
